<template>
  <div>
    <h4 class="mt-2 font-weight-bold text-center text-blue">
      VERIFIKASI WHATSAPP
    </h4>
    <p class="text-center text-blue">
      YesDok membutuhkan verifikasi WhatsApp. Pastikan nomor Anda dibawah ini terhubung ke WhatsApp.
    </p>
    <div class="col-12 input-phone-number">
      <client-only>
        <vue-tel-input
          v-model="whatsapp.number"
          v-bind="bindProps"
          :valid-characters-only="true"
          @onInput="onInput"
          @blur="checkTel"
        />
      </client-only>
      <div v-if="check_whatsapp" class="text-danger mt-2">
        Tolong isi nomor whatsapp Anda
      </div>
    </div>
    <b-button block variant="primary mt-4" :disabled="!whatsapp.number || whatsapp_loading" class="btn-next" @click="submitWhatsapp()">
      LANJUTKAN
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'VerificationWhatsapp',
  data: () => ({
    whatsapp: {
      number: null,
      nationality: null,
      country_code: null
    },

    check_whatsapp: false,
    whatsapp_loading: false,

    bindProps: {
      mode: 'international',
      defaultCountry: 'ID',
      disabledFetchingCountry: true,
      disabled: false,
      disabledFormatting: true,
      placeholder: 'Nomor WhatsApp',
      enabledCountryCode: true,
      enabledFlags: true,
      autocomplete: 'off',
      maxLen: 25,
      wrapperClasses: '',
      inputClasses: '',
      dropdownOptions: {
        disabledDialCode: false
      },
      inputOptions: {
        showDialCode: false
      }
    }
  }),
  methods: {
    onInput ({ number, isValid, country }) {
      if (this.whatsapp.number.charAt(0) === '0') {
        this.whatsapp.number = this.whatsapp.number.substring(1).replace(/-/g, '')
      }
      if (isValid) {
        if (this.whatsapp.number.charAt(0) === '0') {
          this.whatsapp.number = this.whatsapp.number.substring(1)
        }
        this.whatsapp.number = number.input.replace(/-/g, '')
        this.whatsapp.nationality = country.iso2
      }
      this.whatsapp.country_code = '+' + country.dialCode
    },
    checkTel () {
      if (!this.whatsapp.number) { this.check_whatsapp = true; return }
      this.check_whatsapp = false
    },
    submitWhatsapp () {
      const payload = {
        number: this.whatsapp.country_code + this.whatsapp.number,
        token: localStorage.getItem(process.env.TOKEN_NAME)
      }
      this.whatsapp_loading = true
      this.$store.dispatch('patient/changeWhatsapp', payload)
        .then((res) => {
          this.whatsapp_loading = false
          this.$store.commit('doctor/SET_STEP', 'register-otp')
          localStorage.setItem('step', 'register-otp')
        })
        .catch((err) => {
          this.whatsapp_loading = false
          if (err.data) {
            this.$swal({
              title: 'Akun Terblokir',
              text: 'Jika ini adalah kesalahan, hubungi kami di',
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#024668',
              confirmButtonText: 'Tutup'
            })
          }
          this.$store.commit('doctor/SET_STEP', 'register-otp')
          localStorage.setItem('step', 'register-otp')
        })
    }
  }
}
</script>

<style scoped>

</style>
